import script from "./VideoGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoGallery.vue?vue&type=script&setup=true&lang=js"

import "./VideoGallery.vue?vue&type=style&index=0&id=9c4461b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c4461b4"]])

export default __exports__